import React, { useEffect, useState } from 'react'
import { Button, Row, Col, Tooltip, Select, Popover, Spin, Collapse } from 'antd'
import { connect } from 'react-redux'
import { sendTransactionApprove, sendTransactionSendToBank } from '../../../services/Auth/TransactionApprove'
import { BUTTONS } from 'constants/constants'


import './index.scss'

import NextModal from 'components/NextModalTransfers'
import NextModalSalary from 'components/NextModal'
import {
  AsanIco, CheckPayment, DeleteIco, DisabledCheckIcon,
  DocumentsIco,
  DownloadExcel, EditIco,
  NoMoneyIco,
  NoticeIco,
  NoticeLinedIco,
  PdfIco, RollbackIco,
  SpinnerIco,
  SwiftPdfIco,
  XlsIco
} from "../../../../modules/CustomIcons";
import SuccessOrErrorModal from "components/SuccessOrErrorModal";
import CustomTooltip from "components/Tooltip";
import { InfoCircleOutlined } from "@ant-design/icons";
import { checkAmountForRequest } from "../../../services/helper";
import { secureLocalStorageGet } from '../../../helpers';
import { useTranslation } from 'react-i18next'
import i18next from "../../../../i18n";
import DocumentsPreviewModal from 'components/DocumentsPreviewModal'
import { getSwiftPdf } from '../../../services/Transfers/Swift'
import { SimaAdocActiveIcon, SimaAdocInactiveIcon } from '../../../../modules/SimaAdocIcons'

const selectOptions = ['AZ', 'EN','RU']

const TransfersFooter: React.FC<any> = (props) => {
  const {t} = useTranslation()
  const [language,setLanguage] = useState(localStorage.getItem("i18nextLng")?.toUpperCase())
  useEffect(()=>{
    setLanguage(localStorage.getItem("i18nextLng")?.toUpperCase())
  },[localStorage.getItem("i18nextLng")])


  const salaryColumnsdata = [
    {
      title: '№',
      editable: false,
      render: (record: any, text: any, index: number) => {
        return <p>{index + 1}</p>
      }
    },
    {
      title: t("salary.accountHolder"),
      dataIndex: 'employeeName',
      key: 'employeeName',
      width:160,
      editable: false,
    },
    {
      title: t("salary.employeeAccountNumber"),
      dataIndex: 'employeeAccount',
      key: 'employeeAccount',
      editable: false,
    },
    {
      title: t("common.amount"),
      dataIndex: 'employeeAmount',
      key: 'employeeAmount',
      editable: false,
      render: amount => {
        const amount1 = checkAmountForRequest(amount)
        return (
          <>

            {amount1}
          </>
        )
      }
    },
    {
      title: t("transfers.details"),
      dataIndex: 'employeePmtDetail',
      key: 'employeePmtDetail',
      editable: false,

    },
    {
      title: t("newTransfer.note"),
      dataIndex: 'employeePmtNote',
      key: 'employeePmtNote',
      editable: false,
      render: data => {
        return (
          <>
            {data !== null ? <CustomTooltip title={data} ><Button icon={<NoticeLinedIco />} className='transparent' /></CustomTooltip> : <Button icon={<NoticeIco />} className='transparent' />}
          </>
        )
      }
    },
  ]
  const innerColumnsdata = [
    {
      title: t("common.date"),
      dataIndex: 'date',
      key: 'date',
      editable: false,
    },
    {
      title: t("login.userName"),
      dataIndex: 'userName',
      key: 'userName',
      editable: false,
    },
    {
      title: t("transfers.notes"),
      dataIndex: 'notification',
      key: 'notification',
      editable: false,
    },
  ]
  const columnsData = [
    {
      title: t("common.date"),
      dataIndex: 'transactionDate',
      key: 'transactionDate',
      editable: false,
    },
    {
      title: t("login.userName"),
      dataIndex: 'userName',
      key: 'userName',
      editable: false,
    },
    {
      title: t("transfers.actionWithTransaction"),
      dataIndex: 'trnRequestType',
      key: 'trnRequestType',
      editable: false,
    },
    {
      title: t("transfers.acquiredStatus"),
      dataIndex: 'trnStatusAfter',
      key: 'trnStatusAfter',
      editable: false,
    },
  ]
  const  footerBtnsTransferFooter = [
    {
      icon: <PdfIco />,
      title: i18next.t("transfers.downloadOrderPayment"),
      key : 'pdf',
      visible: true
    },
    {
      icon: <XlsIco />,
      title: i18next.t("transfers.downloadExcel"),
      key: 'excel',
      visible: false
    },
    {
      icon: <CheckPayment />,
      title: "Qəbz endir",
      key: 'check',
      visible: false
    },
    {
      icon:<DownloadExcel/>,
      title:i18next.t("transfers.downloadAllExcel"),
      key:'allexcel',
      visible:true
    },
    {
      icon: <AsanIco />,
      title: i18next.t("transfers.downloadAdoc"),
      key: 'adoc',
      visible: false
    },
    {
      // SIMA-signed ADOC: same download as 'adoc' but only for transfers that
      // were signed via SIMA and reached BANK_SUCCESS. The actual icon (active
      // colored vs grey) is chosen at render time from props.disabledSimaAdoc.
      icon: <SimaAdocActiveIcon />,
      title: "“SİMA İmza” sənədini endir",
      key: 'simaadoc',
      visible: false
    },]

  const  footerBtnsFirst = [
    {
      icon: <RollbackIco />,
      title: i18next.t("home.repeat"),
      type: 'repeat',
    },
    {
      icon: <EditIco />,
      title: <div>
        <div style={{marginBottom:'10px', textAlign: "center", fontWeight: 700}}>{i18next.t("transfers.edit2")}</div>
        <div>{i18next.t("transfers.willCancelSignConfirmNotif")}</div>
      </div>,
      type: 'edit'
    },
    {
      icon: <DeleteIco />,
      title: i18next.t("transfers.delete"),
      type: 'delete'
    },
  ]
  const [visible, setVisible] = useState(false);
  const [showSuccessOrError, setShowSuccessOrError] = useState(false)
  const [errorService, setErrorService] = useState("")
  const [popupType, setPopupType] = useState("success")
  const [modalText, setModalText] = useState<string>(props.nextModalText)
  const [loadingSendToBank, setLoadingSendToBank] = useState(false);
  const [documentsModalvisible,setDocumentsModalVisible] = useState(false)

  // let requestTypeLocal = localStorage.getItem('rol')
  let requestTypeLocal = secureLocalStorageGet('rol')
  let requestType = ''
  if (requestTypeLocal == '2') {
    requestType = 'SIGN'
  } else if (requestTypeLocal == '3') {
    requestType = 'APPROVE'
  } else {
    requestType = 'MAKER'
  }
  // console.log(props.selectedType)
  // console.log(requestType)

  const content = (
    <div>
      <p onClick={props.handleGetFileClick} className={'pdf_text'}>{t("transfers.seperatePDF")}</p>
      <p onClick={props.handleGetFileClickMultiple} className={'pdf_text'}>{t("transfers.multiplePDF")}</p>
    </div>
  );

  const newTransferFunc = (value) => {
    let ibankArr = props.fileDescriptors.map((item: number) => {
      return {
        ibankref: item,
      };
    });
    if (props.openedIbanRef !== undefined && props.openedIbanRef !== "") {
      ibankArr = [{
        ibankref: props.openedIbanRef
      }]
    }
    let postData = {
      trnRequestType: value,
      fileDescriptors: ibankArr
    }
    if (value !== "SEND_BANK")
      return sendTransactionApprove(postData)
    else
      return sendTransactionSendToBank(postData)
  }

  const controlDropdownMenu = () => {
    setVisible(false)
  };

  useEffect(() => {
    const layoutScroll = document.getElementById("layout_scroll");
    if (typeof layoutScroll !== 'undefined') {
      layoutScroll?.addEventListener('scroll', controlDropdownMenu);

      return () => {
        layoutScroll?.removeEventListener('scroll', controlDropdownMenu);
      };
    }
  });

  const sendTransactionRequest = (RequestType: string) => {
    setErrorService("")
    setLoadingSendToBank(true)
    newTransferFunc(RequestType).then((res) => {
      setLoadingSendToBank(false)
      if (res?.resultMessage === "SUCCESS") {
        setErrorService("")
        setModalText(t("notification.transferSentToBank"));
        setPopupType('success');
      }
      else {
        if (res?.resultCode !== "500" && res?.resultCode !== "BrServiceErr") {
          if (res?.resultCode === "400") {
            setPopupType('error');
            setModalText(res?.resultMessage);
          } else {
            setErrorService((res?.detail !== undefined ? res?.detail : '' + ' ') + (res?.message !== undefined ? res?.message : '' + ' ') + (res?.resultMessage !== undefined ? res?.resultMessage : ''));
          }
        } else {
          setShowSuccessOrError(true)
          if (props.selectedType === "BANK_ERROR")
            setModalText(t("transfers.useSendToBankButtonAgain"))
          else
            setModalText(t("notification.errorOccuredWhenSendToBank"));
          setPopupType('error');
        }
        setErrorService(res?.resultMessage)
      }
      setShowSuccessOrError(true)
    }).catch((e) => {
      setLoadingSendToBank(false)
      setErrorService(e?.data?.detail)
    })
  }
   const handleGetSwiftPdf = async () => {
  let ibankrefValue: string | number | undefined;

  if (props.openedIbanRef !== undefined && props.openedIbanRef !== "") {
    ibankrefValue = props.openedIbanRef;
  } else if (props.fileDescriptors?.length > 0) {
    ibankrefValue = props.fileDescriptors[0]; 
  }

  if (!ibankrefValue) return;

  const now = new Date();
  const day = String(now.getDate()).padStart(2, "0");
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const year = String(now.getFullYear()).slice(-2);
  const downloadDate = `${day}${month}${year}`;

  const fileName = `SM_${ibankrefValue}_${downloadDate}.pdf`;

  const postData = {
    fileDetailsList: [{ ibankRef: ibankrefValue }],
  };

  try {
    const { data } = await getSwiftPdf(postData);
    if (data) {
      return downloadPDFFile(fileName, data.fileDetailsList[0]?.fileBase64);
    }
  } catch (err: any) {
    console.log("err", err);
  }
};

function downloadPDFFile(fileName: string, fileBase64: string) {
  const linkSource = `data:application/pdf;base64,${fileBase64}`;
  const downloadLink = document.createElement('a');
  downloadLink.href = linkSource;
  downloadLink.download = fileName;
  downloadLink.click();
}


  return (
    <>
      <Row>
        <Col span={24}>
          <div className="flex" style={{ justifyContent: 'space-between' }}>
            <div className="salary-btns">
              {(requestType === 'SIGN' || requestType === 'APPROVE') && props.selectedType !== 'BANK_ERROR' && !props.disabledSignModal ?
                props.loadingApprove ?
                  <div style={{ width: '100px', display: 'flex', alignItems: 'center', justifyContent: 'center',marginBottom:"23px"}}><div className='ant-btn exportLoadingdiv transfer_loading'><Spin indicator={<SpinnerIco />} />
                  </div></div> :
              <Button
                size={'large'}
                htmlType="submit"
                onClick={props.handleSignClick}
                disabled={props.disabledSign}
                className={`blue-button btn ${props.disabledSign ? 'disabled' : ''}`}
              // className={props.disabledSign ? 'disabled' : 'blue-button btn'}
              >
                {requestType === 'SIGN' ? BUTTONS.SIGN : BUTTONS.APPROVE}
              </Button>
                : <></>
              }
              {props.selectedType === 'BANK_ERROR' ?
                loadingSendToBank ?
                  <div className='ant-btn exportLoadingdiv transfer_loading'><Spin indicator={<SpinnerIco />} />
                  </div>
                  : <Button
                    size={'large'}
                    htmlType="submit"
                    disabled={props.selectedRow < 1}
                    onClick={() => sendTransactionRequest("SEND_BANK")}
                    className={`blue-button btn`}
                  >
                    {t("transfers.sendToBank")}
                  </Button>
                : <></>
              }
              {props.modalType !== 'SP'
                ? <NextModal
                  btnType={'APPROVE'}
                  requestType={requestType}
                  disabledSign={props.disabledSignModal}
                  onStatusChange={props.handleStatusChange}
                  nextModalText={t("notification.sendingToBankNotif")}
                  callBackApi={newTransferFunc}
                  visible={props.visibleDetail}
                  data={props.modalData || props.modalDataCommon}
                  // tableTitle ={props.type == 'common' ? '' : t("transfers.transferHistory") }
                  columnsData={columnsData}
                  tableData={props.tableData}
                  documentDetail={props.documentDetail}
                  type={props.type1}
                  onClose={props.onCloseSign}
                  innerColumnsdata={innerColumnsdata}
                  innerrtableData={props.innerrtableData}
                  transferData={props.type == 'common' ? false : true}
                  className={props.type == 'common' ? 'common-modal  no_footer_line modalTransferDetail' : 'no_footer_line modalTransferDetail'}
                  width={850}
                  selectedType={props.selectedType}
                  selectedRow={props.selectedRow}
                  multiple={props.multiple}
                  handleGetFileClick={(value:any)=>props.handleGetFileClick(value)}
                  handleGetFileClickMultiple={props.handleGetFileClickMultiple}
                  handleGetAdocFileClick={props.handleGetAdocFileClick}
                  handleGetSimaAdocFileClick={props.handleGetSimaAdocFileClick}
                  simaAdocVisible={props.simaAdocModalVisible}
                  handleOtherClick={props.handleOtherClick}
                  loadingPdf={props.loadingPdf}
                  handleDelete={props.handleDelete}
                  currentForm={props.currentForm}
                  handleRepeat={props.handleRepeat}
                  handleEdit={props.handleEdit}
                  reLoadData={props.reLoadData}
                  onCloseSuccessModal={() => {
                    props.reLoadData()
                  }}
                  btnData={props.btnData}
                  historyList={props.historyList}
                  handleGetPdfAdditional={props.handleGetPdfAdditional}
                />
                : <NextModalSalary
                  btnType={'APPROVE'}
                  requestType={requestType}
                  disabledSign={props.disabledSignModal}
                  tableTitle={t("salary.employee")}
                  onStatusChange={props.handleStatusChange}
                  nextModalText={t("notification.sendingToBankNotif")}
                  callBackApi={newTransferFunc}
                  visible={props.visibleDetail}
                  data={props.modalData || props.modalDataCommon}
                  // tableTitle ={props.type == 'common' ? '' : t("transfers.transferHistory") }
                  columnsData={salaryColumnsdata}
                  tableData={props.salaryData}
                  columnsDataTransfer={columnsData}
                  type={props.type}
                  transferSp={true}
                  onClose={props.onCloseSign}
                  innerColumnsdata={innerColumnsdata}
                  innerrtableData={props.innerrtableData}
                  transferData={props.type == 'common' ? false : true}
                  className={props.type == 'common' ? 'common-modal  no_footer_line' : 'no_footer_line'}
                  salary={true}
                  currentForm={props.currentForm}
                  transferSP={true}
                  btnData={props.btnData}
                  width={850}
                  selectedType={props.selectedType}
                  selectedRow={props.selectedRow}
                  // multiple={props.multiple}
                  handleGetFileClick={props.handleGetFileClick}
                  handleGetFileClickMultiple={props.handleGetFileClickMultiple}
                  handleGetAdocFileClick={props.handleGetAdocFileClick}
                  handleOtherClick={props.handleOtherClick}
                  loadingPdf={props.loadingPdf}
                  handleDelete={props.handleDelete}
                  handleRepeat={props.handleRepeat}
                  handleEdit={props.handleEdit}
                  reLoadData={props.reLoadData}
                  onCloseSuccessModal={() => {
                    props.reLoadData()
                  }}
                  historyList={props.historyList}
                  handleGetPdfAdditional={props.handleGetPdfAdditional}
                  modalType={props.modalType}
                  openedIbanRef={props.openedIbanRef}
                />}

            </div>

            <div className="transfers-footer_btns1 flex">

           { <div
           className='flex align_center'
           >
            {/* {console.log(props.documentDetail.transferDocs)} */}
            {
                
                <div
                style={{height:'72%',margin:'0 10px'}}
                className='flex align_center'
                >
                   <DocumentsPreviewModal
                visible={documentsModalvisible}
                title={t("modal.modalTitleDocs")}
                page={true}
                children={<h1>documents modal</h1>}
                // onBack={() => }
                data={props.documentDetail}
                onCancel={() => {
                  setDocumentsModalVisible(false);
                }}
                className='documents_modal'
              />
              <Button
                  style={{height:'72%'}}
                  size={'large'}
                  className="transfer_documentButton_main  light-button  refresh_btn btn flex align_center justify_center"
                  >
                    <Tooltip title={t("common.swiftTooltipText")}>
                      <div style={{ display: "inline-flex" }}>
                        <Button
                          icon={<SwiftPdfIco />}
                          className="flex transfer_documentButtonn"
                          disabled={
                            !(
                              (props.type === "SWIFT" || props.type === "SWIFT_RUB" ||  props.type === "FP" || props.type === "RP") &&
                              props.selectedRow === 1 &&
                              props.selectedType === "CLOSED"
                            )
                          }
                          onClick={handleGetSwiftPdf}
                        />
                      </div>
                    </Tooltip>
                 <Button
                  icon={<DocumentsIco className=''/>}
                  className='flex transfer_documentButton'
                  disabled={!((props.type == 'SWIFT' || props.type === 'SWIFT_RUB' || props.type === "FP" || props.type === "RP") && props.selectedRow ===1)}
                  onClick={(e) => {
                    console.log('documents opened');
                    setDocumentsModalVisible(true);
                  }}
                >
                <p style={{color:"#015CD1"}}>
                {((props.type === 'SWIFT' || props.type === 'SWIFT_RUB' || props.type === "FP" || props.type === "RP") && props.selectedRow ===1 && props.documentDetail?.length !==undefined) ?   props.documentDetail?.length :''}
                </p>
                </Button>
              </Button>
                 
              </div>
              }
            </div>}
              <ul
                className="flex"
                style={{ marginRight: '30px', marginTop: '30px' }}
              >
                {footerBtnsFirst.map((item) => {
                  return (
                    <li>

                      <Tooltip className='footer-tooltip' title={item.title} >

                        <Button ghost
                          icon={item.icon}
                          disabled={
                            props.type !== 'GPP' ?
                            (item.type === 'repeat' ?
                            props.disabledRepeat : (item.type === 'edit'
                              ? props.disabledEdit
                              : props.disabledDelete)) : (item.type ==='delete' ? props.disabledDelete : true)}

                          onClick={item.type === 'repeat' ?
                            props.handleRepeat : (item.type === 'edit'
                              ? props.handleEdit
                              : props.handleDelete)}
                        />
                      </Tooltip>
                    </li>
                  )
                })}
              </ul>

              <ul
                className="flex"
                style={{ marginRight: '30px', marginTop: '30px' }}
              >
                <li>
                  <div className="pagination-selector language-selector" style={{ left: '0px', margin: '5px 20px auto 0px' }}>
                    <Select
                      // open={true}
                      defaultValue={"AZ"}
                      // placeholder="AZ"
                      width={64}
                      onChange={props.handleSelectLanguage}

                    >
                      {selectOptions.map((item) => {
                        return <option value={item}>{item}</option>
                      })}
                    </Select>
                  </div>
                </li>
                {footerBtnsTransferFooter.map((item) => {
                  return (
                    <li>

                      {item.key == 'pdf' ?
                        props.loadingPdf ?
                          <div className='ant-btn exportLoadingdiv'><Spin indicator={<SpinnerIco />} /></div>
                          :
                          (props.selectedRow > 1 ?
                            <Popover
                              // className = "btn-popover"
                              placement="top"
                              content={content}
                              trigger="click"
                              visible={visible}
                              onVisibleChange={() => setVisible(!visible)}
                            >
                              <Tooltip className='footer-tooltip' title={item.title}>
                                <Button
                                  icon={item.icon}
                                  disabled={props.disabledPDF}
                                />
                              </Tooltip>
                            </Popover> :
                            <Tooltip className='footer-tooltip' title={item.title}>
                              <Button
                                icon={item.icon}
                                disabled={props.disabledPDF}
                                onClick={props.handleGetFileClick}
                              />
                            </Tooltip>
                          )
                        : (item.key==='excel'? <Tooltip className='footer-tooltip' title={item.title}>
                          {
                            props.loadingExcel && item.key !== 'adoc' && item.key !== "swift" ?
                              <div className='ant-btn exportLoadingdiv'><Spin indicator={<SpinnerIco />} /></div>
                              :
                              <Button

                                icon={item.icon}
                                disabled={item.key == 'adoc' ? props.disabledADOC : (item.key == "swift" ? props.disabledSwift : props.disabledXLS)}
                                onClick={item.key == 'adoc' ? props.handleGetAdocFileClick : props.handleGetExcelAdditional}
                              />
                          }
                        </Tooltip> :
                                  <Tooltip className='footer-tooltip' title={item.title}>

                                   {
                                      props.loadingAll && item.key !== 'adoc' && item.key !== "swift" ?
                                          <div className='ant-btn exportLoadingdiv'><Spin indicator={<SpinnerIco />} /></div>
                                          :(item.key==='check' ? <Button
                                                  className={'none-fill'}
                                                  icon={!props.disabledReceipt && props.selectedType === 'CLOSED'  ? item.icon
                                                      :<DisabledCheckIcon /> }
                                              disabled={ props.disabledReceipt}
                                              onClick={props.handleDownloadCheck}
                                              />:
                                          <Button
                                              icon={item.key == 'simaadoc' ? (props.disabledSimaAdoc ? <SimaAdocInactiveIcon className="sima-adoc-icon" /> : <SimaAdocActiveIcon className="sima-adoc-icon" />) : item.icon}
                                              disabled={item.key == 'adoc' ? props.disabledADOC : (item.key == 'simaadoc' ? props.disabledSimaAdoc : false)}
                                              onClick={item.key == 'allexcel' ? props.handleGetAllExcel : (item.key=="simaadoc" ? props.handleGetSimaAdocFileClick : (item.key=="adoc" ? props.handleGetAdocFileClick : props.handleGetExcelAdditional))}
                                          />)
                                    }
                                  </Tooltip>
                          )

                      }
                    </li>
                  )
                })}
              </ul>
            </div>
          </div>
        </Col>
      </Row>
      {showSuccessOrError && (
        <SuccessOrErrorModal
          visible={showSuccessOrError}
          modalType={popupType}
          modalTitle={popupType === 'success' ? t("home.transfer") : t("notification.attention")}
          modalText={modalText}
          onClose={() => { popupType === 'success' ? props.setButtonClickedTriggerChildFunc() : props.reLoadData(); setShowSuccessOrError(false) }}
          // onClose={() => { props.reLoadData(); setShowSuccessOrError(false) }}
        />
      )}
    </>
  )
}
export default connect(null, null)(TransfersFooter)
